import { createAction } from '@reduxjs/toolkit';
import { _contentfulPost } from "../utils/services/api.service";

export const setSearchCourses = createAction('SET_SEARCH_COURSES');
export const setFooterHeight = createAction('SET_FOOTER_HEIGHT');
export const setCheckedFellowshipRegions = createAction('SET_CHECKED_FELLOWSHIP_REGIONS');
export const setActiveFormats = createAction('SET_ACTIVE_FORMATS');
export const setCheckedFellowshipYears = createAction('SET_CHECKED_FELLOWSHIP_YEARS');
export const setFellowshipSearchName = createAction('SET_FELLOWSHIP_SEARCH_NAME');
export const setFellowsSearchResults = createAction('SET_FELLOWS_SEARCH_RESULTS');
export const setFellowsSearchResultsLimit = createAction('SET_FELLOWS_SEARCH_RESULTS_LIMIT');
export const setAllCourses = createAction('SET_ALL_COURSES');
export const setFiltersAreDisabled = createAction('SET_FILTERS_ARE_DISABLED');
export const setActiveTopics = createAction('SET_ACTIVE_TOPICS');
export const setActivePaymentType = createAction('SET_ACTIVE_PAYMENT_TYPE');
export const setActiveAvailabilityType = createAction('SET_ACTIVE_AVAILABILITY_TYPE');
export const setPendingCourseEnrollmentNotification = createAction('SET_PENDING_COURSE_ENROLLMENT_NOTIFICATION');
export const setActiveTimeframe = createAction('SET_ACTIVE_TIMEFRAME');
export const setActiveSortValue = createAction('SET_ACTIVE_SORT_VALUE');
export const setSearchCriteria = createAction('SET_SEARCH_CRITERIA');

// Thunk to setup courses
export const setupCourses = (courses) => {
  return (dispatch, getState) => {
    const { allCourses } = getState().courseReducer;
    let coursesToSetup = allCourses || courses,
      selectedFormats = {},
      selectedTopics = {};
    
    coursesToSetup.forEach(course => {
      selectedFormats[course.theme ? course.courseType : course.productType] = true;
      selectedTopics[course.theme ? course.theme.theme.toLowerCase() : course.courseType.toLowerCase()] = true;
    });

    dispatch(setActiveFormats(selectedFormats));
    dispatch(setActiveTopics(selectedTopics));
  };
};

// Thunk to get search results
export const getSearchResults = () => {
  return async (dispatch, getState) => {
    const {
      checkedFellowshipRegions,
      checkedFellowshipYears,
      fellowshipSearchResultsLimit,
      searchName,
    } = getState().fellowsReducer;

    const results = await _contentfulPost({
      query: `query($name: String, $region: [String], $year: [String], $limit: Int) {
        nameImageDetailsCollection (where: {
          AND: [
            {name_contains: $name},
            {AND: [{region_contains_some: $region}, {year_contains_some: $year}]}
          ]
        },
        limit: $limit) {
          items {
            name
            region
            year
            bioLong
            photoLogo { url }
            cta { url }
          }
        }
      },`,
      variables: {
        name: searchName,
        region: checkedFellowshipRegions,
        year: checkedFellowshipYears,
        limit: fellowshipSearchResultsLimit,
      },
    });

    dispatch(setFellowsSearchResults(results.nameImageDetailsCollection.items));
  };
};

// Thunk for catalog search format filters
export const setCatalogSearchFormatFilters = (formats) => {
  return (dispatch, getState) => {
    formats = formats.map(format => format?.split("es")[0]).filter(Boolean);
    const { activeFormats } = getState().courseReducer;
    const updatedActiveFormats = { ...activeFormats };

    Object.keys(updatedActiveFormats).forEach(format => {
      updatedActiveFormats[format] = formats.includes(format);
    });

    dispatch(setActiveFormats(updatedActiveFormats));
    dispatch(setSearchCourses());
  };
};

// Thunk for catalog search topic filters
export const setCatalogSearchTopicFilters = (topics) => {
  return (dispatch, getState) => {
    topics = topics.filter(Boolean);
    const { activeTopics } = getState().courseReducer;
    const updatedActiveTopics = { ...activeTopics };

    Object.keys(updatedActiveTopics).forEach(topic => {
      updatedActiveTopics[topic] = topics.includes(topic);
    });

    dispatch(setActiveTopics(updatedActiveTopics));
    dispatch(setSearchCourses());
  };
};

// Thunk for catalog search availability filters
export const setCatalogSearchAvailabilityFilters = (availability) => (dispatch) => {
  dispatch(setActiveAvailabilityType(availability));
  dispatch(setSearchCourses());
};

// Thunk for catalog search payment filters
export const setCatalogSearchPaymentFilters = (payment) => (dispatch) => {
  dispatch(setActivePaymentType(payment));
  dispatch(setSearchCourses());
};

// Thunk to sort courses
export const sortCourses = (sort) => (dispatch) => {
  dispatch(setActiveSortValue(sort));
  dispatch(setSearchCourses());
};

// Thunk to set timeframe filter
export const setCoursesTimeframeFilter = (timeframe) => (dispatch) => {
  dispatch(setActiveTimeframe(timeframe));
  dispatch(setSearchCourses());
};

// Thunk to reset search courses
export const resetSearchCourses = () => (dispatch, getState) => {
  const { activeFormats, activeTopics } = getState().courseReducer;
  let updatedFormats = {}, updatedTopics = {};

  Object.keys(activeFormats).forEach(format => (updatedFormats[format] = true));
  Object.keys(activeTopics).forEach(topic => (updatedTopics[topic] = true));

  dispatch(setActiveTopics(updatedTopics));
  dispatch(setActiveFormats(updatedFormats));
  dispatch(setActiveAvailabilityType("All"));
  dispatch(setActivePaymentType("All"));
  dispatch(setSearchCourses());
};
